module.exports = __webpack_public_path__ + "img/itabg.f36f2d2f.jpg";